export enum Currency {
  CL = '$',
}
